import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { ItemNavigation } from '../store/chats.reducer';

@Component({
  selector: 'dmcom-items-navigation',
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-col h-full w-full gap-4">
      @for (item of items(); track item.id) {
        <div
          class="relative w-full flex items-center justify-between gap-4 typo-p3 p-8 h-36 rounded-lg cursor-pointer hover:bg-grayscale-gray-light-48 text-grayscale-gray-darker"
          [class.bg-grayscale-gray-light-48]="item.selected"
          (click)="selectItem(item)"
        >
          <span
            [title]="item.title"
            class="max-w-full whitespace-nowrap overflow-hidden text-ellipsis py-2"
            [class.font-semibold]="item.selected"
            >{{ item.title }}</span
          >
        </div>
      }
    </div>
  `,
})
export class ItemsNavigationComponent {
  public readonly isMobile = input<boolean>(false);
  public readonly items = input.required<ItemNavigation[]>();
  public readonly itemClicked = output<ItemNavigation>();

  public selectItem(item: ItemNavigation): void {
    const selectedItem = this.items().find((t) => t.id === item.id);

    if (selectedItem) {
      this.itemClicked.emit(selectedItem);
    }
  }
}
